"use client";

import Link from "next/link";
import React from "react";

interface NavbarGradientButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  link?: string;
  onRequestDemo?: () => void;
}

export default function NavbarGradientButton({
  children,
  onClick,
  className = "",
  link = "/login",
  onRequestDemo,
}: NavbarGradientButtonProps) {
  // Check if this is a request_demo link
  const isRequestDemo = link === "request_demo";

  const handleClick = (e: React.MouseEvent) => {
    if (isRequestDemo && onRequestDemo) {
      e.preventDefault();
      onRequestDemo();
    }
    if (onClick) {
      onClick();
    }
  };

  const buttonClassName = `
    cursor-pointer
    bg-[#D4A84B]
    px-6 py-2 rounded-full text-black font-medium
    transition-all duration-300 ease-in-out
    hover:brightness-110 hover:scale-105
    active:scale-95
    ${className}
  `;

  // If it's a request_demo link, render as button
  if (isRequestDemo) {
    return (
      <button onClick={handleClick} className={buttonClassName}>
        {children}
      </button>
    );
  }

  // Otherwise, render as Link
  return (
    <Link href={link} onClick={handleClick} className={buttonClassName}>
      {children}
    </Link>
  );
}
